import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import "../../../styles/ValidationForm.css"
import GlassCard from '../../../shared/components/card/GlassCard';
import VerificationForm from '../components/ValidationForm';


const VerificationCodePage = ({type = false}) => {
  const { mfaVerify,mfaResend,changeMfaForgotPass,sendForgotPassMfa,stepOneForgotPassword,mfaForgotPass,acceptEula,setIsEulaAccepted} = useAuth();
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const inputRefs = useRef([]);

  // Auto-focus en el primer input al montar
  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

    // Función para mapear errores específicos
  const getErrorMessage = (err) => {
    const statusCode = err?.response?.status;
    const serverMessage = err?.response?.data?.message;
    const errorCode = err?.response?.data?.error || err?.code;

    // Error específico del servidor
    if (serverMessage) return serverMessage;

    // Errores por código de estado HTTP
    switch (statusCode) {
      case 400:
        return 'Código inválido. Verifica e intenta de nuevo.';
      case 401:
        return 'Código incorrecto o expirado.';
      case 403:
        return 'Demasiados intentos. Cuenta bloqueada temporalmente.';
      case 404:
        return 'Sesión no encontrada. Inicia sesión nuevamente.';
      case 408:
      case 409:
        return 'Código expirado. Solicita uno nuevo.';
      case 429:
        return 'Demasiados intentos. Espera unos minutos.';
      case 500:
        return 'Error del servidor. Intenta más tarde.';
      default:
        break;
    }

    // Errores específicos de MFA
    const mfaErrors = {
      INVALID_CODE: 'Código incorrecto. Verifica e intenta de nuevo.',
      CODE_EXPIRED: 'El código ha expirado. Solicita uno nuevo.',
      MAX_ATTEMPTS: 'Demasiados intentos fallidos. Cuenta bloqueada.',
      SESSION_INVALID: 'Sesión inválida. Inicia sesión nuevamente.',
      SESSION_EXPIRED: 'Sesión expirada. Inicia sesión nuevamente.',
      MFA_NOT_ENABLED: 'Verificación en dos pasos no activada.',
    };

    if (mfaErrors[errorCode]) return mfaErrors[errorCode];

    // Errores de red/conexión
    switch (errorCode) {
      case 'ECONNABORTED':
      case 'TIMEOUT':
        return 'Tiempo de espera agotado. Revisa tu conexión.';
      case 'NETWORK_ERROR':
      case 'ERR_NETWORK':
        return 'Sin conexión a internet.';
      case 'ECONNREFUSED':
        return 'No se pudo conectar con el servidor.';
      default:
        break;
    }

    return 'Error al verificar el código. Intenta de nuevo.';
  };

  const triggerError = (message) => {
    setError(message);
    setShake(true);
    setCode(['', '', '', '', '', '']); // Limpiar código
    setTimeout(() => {
      setShake(false);
      inputRefs.current[0]?.focus(); // Volver al primer input
    }, 500);
  };

  const handleSubmit = async (fullCode) => {

      // Validación local
    if (fullCode.length !== 6) {
      triggerError('Ingresa los 6 dígitos del código.');
      return;
    }

    if (!/^\d{6}$/.test(fullCode)) {
      triggerError('El código debe contener solo números.');
      return;
    }

    setIsLoading(true);
    setError('');
    setShake(false);
    try {
        // Obtener sessionId del localStorage
        const sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
          throw { response: { status: 404, data: { message: 'Sesión no encontrada. Inicia sesión nuevamente.' } } };
        }
        
        console.log("sessionId: " + sessionId, "code: " + fullCode);
        
        let data;
        
        if (type) {
          // sendForgotPassMfa - sin validación de keys
          const obj = { sessionId: sessionId, code: fullCode }
          console.log("El objeto",obj)
          try {
            data = await sendForgotPassMfa(obj);
            changeMfaForgotPass(true);
            console.log("mfaForgotPass",mfaForgotPass)
            console.log("stepOneForgotPassword",stepOneForgotPassword)
            console.log("2. Respuesta OK:", data)
            
          } catch (e) {
            console.log("3. Status:", e.response?.status)
            console.log("4. Body del error:", e.response?.data)
            console.log("5. Headers enviados:", e.config?.headers)
            throw e; // re-lanzar para que lo capture el catch de arriba
          }
        } else {
          // mfaVerify - con validación de keys
          data = await mfaVerify({ sessionId: sessionId, code: fullCode });

          const expectedKeys = ['accessToken', 'refreshToken', 'accessTokenExpires', 'refreshTokenExpires'];
          const hasAllKeys = expectedKeys.every(key => key in data);
          
          if (!hasAllKeys) {
            throw { 
              response: { 
                status: 500, 
                data: { message: 'Respuesta incompleta del servidor' } 
              } 
            };
          }
        }
        
    } catch (error) {
      console.error('Error en verificación MFA:', error);
      const errorMessage = getErrorMessage(error);
      triggerError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };  

    // Reenviar código
  const handleResend = async () => {
    setError('');
    setShake(false);
    setCode(['', '', '', '', '', '']);
    // Aquí llamarías a tu API para reenviar el código
    // await resendMfaCode(sessionId);
    inputRefs.current[0]?.focus();
    mfaResend();
  };

  const isComplete = code.every(c => c !== '');

  return (
    <div className="verify-container">
      <GlassCard paddingTopBottom='28px'>
        <VerificationForm 
          code={code} 
          setCode={setCode} 
          handleSubmit={handleSubmit} 
          isLoading={isLoading} 
          isComplete={isComplete} 
          error={error}
          shake={shake}
          onResend={handleResend}
        />
      </GlassCard>
    </div>
  );
};

export default VerificationCodePage;